import { useNavigate } from "react-router-dom";
import { Lock, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function AccessGate({ children }) {
  const { auth } = useAuth();
  const navigate = useNavigate();
  if (!auth) return null;
  if (auth.has_access) return children;
  return (
    <div data-testid="access-gate" className="max-w-lg mx-auto mt-10 rounded-2xl border border-border bg-card/60 p-8 text-center">
      <div className="w-14 h-14 rounded-2xl bg-primary/10 border border-primary/25 flex items-center justify-center mx-auto mb-5">
        <Lock className="w-6 h-6 text-primary" />
      </div>
      <h2 className="font-heading font-bold text-2xl mb-2">Subscription required</h2>
      <p className="text-muted-foreground mb-6">
        Your free trial has ended. Subscribe to the Monthly Pro plan to keep posting loads, browsing trucks and messaging transporters.
      </p>
      <Button data-testid="gate-subscribe-btn" onClick={() => navigate("/app/subscription")} className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90">
        <CreditCard className="w-4 h-4 mr-2" /> View plans
      </Button>
    </div>
  );
}
